'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Form = function Form(_ref) {
    var children = _ref.children,
        className = _ref.className,
        id = _ref.id,
        onSubmit = _ref.onSubmit,
        onReset = _ref.onReset,
        onChange = _ref.onChange,
        inline = _ref.inline;

    var formClassNames = (0, _classnames2.default)('luna-form', className, {
        'luna-form--inline': inline
    });
    var handleChange = function handleChange(e) {
        e.preventDefault();
        if (onSubmit) {
            onSubmit(e);
        }
    };
    return _react2.default.createElement("form", { className: formClassNames, onChange: onChange, onSubmit: handleChange, onReset: onReset, id: id }, children);
};
Form.propTypes = {
    children: _propTypes2.default.node.isRequired,
    className: _propTypes2.default.string.isRequired,
    onSubmit: _propTypes2.default.func.isRequired,
    onReset: _propTypes2.default.func.isRequired,
    id: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    inline: _propTypes2.default.bool
};
Form.defaultProps = {
    inline: false
};
exports.default = Form;
//# sourceMappingURL=Form.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Form/Form.js